// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_3b839aee","outerContainer":"_7e55e513","secondaryToolbar":"_14fd5787","doorHangerRight":"_8b6ca804","toolbarContainer":"_65dffa0b","toolbarViewerMiddle":"_7e3eeb6d","progressBar":"_40b39d7d","back-to-application":"_08fc13b2","item--minimized":"f99847ca","item--active":"_844368b8","avatar__wrapper":"_1ea53b7b","badge__wrapper":"dcaf3128","card":"_2ac57c0a","card--active":"_037dc3df"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/ChatsList/index.styl
// module id = 5011
// module chunks = 39